import { createContext, useContext } from 'react';
import type { ChangePasswordInput, LoginInput, SessionUser } from '@kn/shared';

export interface AuthContextValue {
  user: SessionUser | null;
  /** Vrai tant que l'identite n'a pas ete resolue au premier chargement. */
  isLoading: boolean;
  login: (input: LoginInput) => Promise<SessionUser>;
  logout: () => Promise<void>;
  changePassword: (input: ChangePasswordInput) => Promise<SessionUser>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (!value) {
    throw new Error("useAuth doit être utilisé à l'intérieur d'un AuthProvider");
  }
  return value;
}
